module.exports = __webpack_public_path__ + "static/img/evolução-ações.1563b19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/evolução-ações.png
// module id = okcp
// module chunks = 1